import { useState, useEffect } from "react";
import Cuenta from "components/cuentas/Cuenta";
import "components/generales/Styles.css";
import Navbar from "components/generales/Navbar";
import Boton from "components/boton/Boton";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ListadoCuentas = () => {
  const [cuentas, setCuentas] = useState([]);
  const navigate = useNavigate();

  //Consultar una API
  useEffect(() => {
    const obtenerListadoCuentasAPI = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = "https://mymoney5.herokuapp.com/cuentas/";
        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCuentas(data);
      } catch (error) {
        console.log(error);
      }
    };
    obtenerListadoCuentasAPI();
  }, []);
  const handleEliminar = async (id_cuenta) => {
    const confirmar = window.confirm("¿Deseas eliminar esta cuenta?");
    if (confirmar) {
      try {
        const token = localStorage.getItem("token"); // validar token
        const url = `https://mymoney5.herokuapp.com/cuentas/${id_cuenta}`;
        const respuesta = await fetch(url, {
          method: "PATCH",
          headers: { Authorization: `Bearer ${token}` },
        });
        const arrayCuentas = cuentas.filter(
          (cuenta) => cuenta.id_cuenta !== id_cuenta
        );
        setCuentas(arrayCuentas);
      } catch (error) {}
    }
  };
  return (
    <>
      <Navbar />

      <div className="lista-preview">
        <h2>Listado de Cuentas</h2>
        <p>Cuentas registradas</p>

        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Tipo</th>
              <th>Saldo actual</th>
              <th>Fecha de corte</th>
              <th>Opciones</th>
            </tr>
          </thead>

          <tbody>
            {cuentas.map((cuenta) => (
              <Cuenta
                key={cuenta.id_cuenta}
                cuenta={cuenta}
                handleEliminar={handleEliminar}
              />
            ))}
          </tbody>
        </table>
        <Boton
          type="button"
          buttonStyle="botonTransparente"
          onClick={() => navigate(`/cuentas/nueva`)}
        >
          Registrar nueva cuenta
        </Boton>
      </div>
    </>
  );
};

export default ListadoCuentas;
